import React from "react";

import DropAreaPlaceholder from "../../images/drop-area-placeholder.svg?react";
import DropAreaPlaceholderActive from "../../images/drop-area-placeholder-active.svg?react";
import "./imageDropAreaPlaceholder.scss";

const ImageDropAreaPlaceholder = ({ isActive }) => {
  return (
    <div className="droparea-placeholder">
      {isActive ? <DropAreaPlaceholderActive /> : <DropAreaPlaceholder />}
      <div className="droparea-placeholder-title">Drag &amp; Drop Items</div>
    </div>
  );
};

export default ImageDropAreaPlaceholder;
